import type { OptionsDocument, EmailTemplate, UserPreferencesDocument } from 'paintscout'
import reduce from 'lodash/reduce'
import uniq from 'lodash/uniq'
import { getFeature } from '../get-features'

export function getCustomEmailTemplates({
  options,
  userPreferences
}: {
  options: OptionsDocument
  userPreferences: UserPreferencesDocument
}): { [key: string]: EmailTemplate } {
  const optionEmails = options?.options?.emails?.customTemplates?.values ?? {}
  const userEmails = userPreferences?.emails?.customTemplates?.values ?? {}

  const hasProfileCommunications = !getFeature({
    options,
    preferences: userPreferences,
    path: 'settingsCommunications.enabled'
  })
  const emails = {
    ...optionEmails,
    ...(hasProfileCommunications ? userEmails : {})
  }

  // merge email additionalRecipient values
  const emailsWithMergedRecipients = reduce(
    emails,
    (result, email, key) => {
      const optionRecipients = optionEmails[key] ? optionEmails[key].additionalRecipients ?? [] : []
      const userRecipients = userEmails[key] ? userEmails[key].additionalRecipients ?? [] : []

      return {
        ...result,
        [key]: {
          ...email,
          additionalRecipients: uniq([...(hasProfileCommunications ? userRecipients : []), ...optionRecipients])
        }
      }
    },
    { ...emails }
  )

  return emailsWithMergedRecipients
}
